export const REDIRECT_TO = 'redirect_to'
